import React from "react";

export default function About() {
    return (
        <section id="about" className="text-white body-font bg-cover bg-no-repeat bg-center pt-32" style={{
            'background-image':'linear-gradient(rgba(240, 249, 255, 0.9), rgba(3, 105, 161, 0.8)), url("./subpage_banner_4.jpg")'
        }}>
            <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                <h1 className="title-font sm:text-4xl text-3xl mb-4 font-black text-white">
                    Design/Management of Edge Devices
                <br className="lg:inline-block" />Data Analytics for IIoT
                </h1>
                <p className="mb-8 leading-relaxed font-bold">
                    Improving operational performance and efficiency using the <a class="font-bold">
                    Industrial Internet of Things (IIoT)</a>
                </p>
                <div className="flex justify-center">
                <a
                    href="#contact"
                    className="inline-flex text-white font-bold bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
                    Work With Us
                </a>
                <a
                    href="#projects"
                    className="ml-4 inline-flex text-gray-50 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
                    Current Deployments
                </a>
                </div>
                </div>
            </div>
        </section>
    )
}



// WEBPACK FOOTER //
// ./src/components/About.js